var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ckeditor',{attrs:{"config":_vm.editorConfig},on:{"input":function($event){return _vm.$emit('input', _vm.editorData)}},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})}
var staticRenderFns = []

export { render, staticRenderFns }